$(function() {
  var height = $("header").outerHeight();
  $("body").css("margin-top", height + "px");
});

$(window).on('load resize', function () {

  $('.p-common__title > img').each(function () {
    const $img = $(this);

    // 元サイズを初回だけ保存
    if (!$img.data('ow')) {
      $img.data({
        ow: this.naturalWidth,
        oh: this.naturalHeight
      });
    }

    const ow = $img.data('ow');
    const oh = $img.data('oh');

    if ($(window).width() <= 992) {
      $img.css({
        width: ow * 0.55 + 'px',
        height: oh * 0.55 + 'px'
      });
    } else {
      // PCは元サイズに戻す
      $img.css({
        width: ow + 'px',
        height: oh + 'px'
      });
    }
  });

});

// // ハンバーガーメニュー
// document.addEventListener('DOMContentLoaded', function () {
//   const menuToggle = document.querySelector('.js-menu-toggle');
//   const subnav = document.querySelector('.l-header__subnav');
//   const overlay = document.querySelector('.l-header__overlay');

//   if (menuToggle && subnav && overlay) {
//     // メニュー開閉ボタンを押したとき
//     menuToggle.addEventListener('click', function () {
//       subnav.classList.add('js-subnav');
//       overlay.classList.add('js-overlay');
//     });

//     // オーバーレイを押したとき
//     overlay.addEventListener('click', function () {
//       subnav.classList.remove('js-subnav');
//       overlay.classList.remove('js-overlay');
//     });
//   }
// });

// // 町域マスタを取得
// //初期処理
// function init() {
// }

// //市区町村選択
// function cityChg() {
//   var city_cd = document.getElementById('req_citycd').value;

//   fetch('/assets/js/town_master.json')
//     .then(res => res.json())
//     .then(master => {
//       var towns = master[city_cd] || [];
//       $('#req_towncd').empty().append('<option value="0">町域を選択</option>');
//       towns.forEach(function(row){
//         $('#req_towncd').append('<option value="'+row[0]+'">'+row[1]+'</option>');
//       });
//     });
// }

// //査定検索(種別・価格帯)
// function sateiClick() {
//   var req_type = document.getElementById('req_type').value;
//   if (req_type == 0) {
//     alert("種別を選択して下さい。");
//     return false;
//   }
//   var req_citycd = document.getElementById('req_citycd').value;
//   if (req_citycd == 0) {
//     alert("市区町村を選択して下さい。");
//     return false;
//   }

//   var req_towncd = document.getElementById('req_towncd').value;
//   if (req_towncd == 0) {
//     alert("町域を選択して下さい。");
//     return false;
//   }

//   document.form1.action = "/satei/";
//   document.form1.submit();
// }


// ページトップ
$(function () {
  var topBtn = $('.l-footer__pagetop');
  topBtn.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });
});

// スクロールを滑らかにする
$(function () {
  $('a[href^="#"]').click(function () {
    var gap = $("header").height();
    var speed = 300;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - gap;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

// ハンバーガーメニュー
$(function() {
  $('.h_menu').click(function() {
    if(window.innerWidth <= 992){
      $('.h_menu>a').toggleClass('is_open');
      $('.h_list').slideToggle();
      // $('.bg_section').toggleClass('is_bg');
      $("body,html").toggleClass("over_hidden");
    }
  });
  $('.bg_section').click(function() {
    if(window.innerWidth <= 992){
      $('.h_menu>a').removeClass('is_open');
      $('.h_list').slideUp();
      // $('.bg_section').removeClass('is_bg');
      $("body,html").removeClass("over_hidden");
    }
  });
});